module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA8UExURUdwTBRr9Q9l+xZr9RZr9gdo9xJq9hVq9RZr9QBR5xVr9hZp9RNp9hVq9hJp9BRq9hRp9RZq9Rdr9Rdr9dWDQ3YAAAATdFJOUwBMD8ytCi1q5ASPilOWJKFgf/HYpDE0AAAAp0lEQVQoz9WS0Q6DIAxFgUo7Jxjx/v+/Ti0wFR/ckj3sJJDenECagjE36V2lb60jVMg1ekKSTMLUaAGXkiH/pAO6CkI7l0gL87zu8XKqyyLKxdkpRLk42vGhALkYD9ruGtuasyfN+8gfaMcsCMxeo2cOEGZX2sq/QPs5RZMQ7ErQWUqNadMD9FZfdInD77UgPleiftCpRn111+U5d9sxf4zv5zLX8Xte42AMtBuDtxwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/more1.png
// module id = Ajqr
// module chunks = 0